import React from 'react';
import ParkingSlotsInfo from "./parkingSlots/ParkingSlotsInfo";
import ParkingSlotTableContainer from './../containers/ParkingSlotTableContainer';
import ParkingSlotGraphContainer from './../containers/ParkingSlotGraphContainer';
import Modal from 'react-modal';
import { I18n } from 'react-redux-i18n';
import Select from 'react-select';

const ParkingPage = ({
    slotsData: {
        totalSlotsData = { },
        categoriesData = []
    },
    table: {
        searchFields: tableSearchFields,
        ...tableProps
    },
    
    graph: {
      searchFields: graphSearchFields,  
      ...graphProps
        
    },

    changeCategoryModal: {
        open: modalIsOpen,
        loadingRequest: categoryModalLoading,
        error: categoryModalError,
        selectedSlot: {
            name: selectedSlotName,
            originalCategory,
            selectedCategory,
            slotsData
        }
    },

    searchFieldsData,
    handleFetchData = () => { },
    handleCleanAllClicked = () => { },
    handleSearchFieldValueChanged = () => { },

    onCollapseCategoryDataClicked = () => { },

    handleParkingTableSlotClicked = () => { },
    handleModalClose = () => { },
    handleSlotCategoryChanged = () => { },
    handleChangeCategorySubmit = () => { }
}) => {
    return (
      <div className="parking-page-wrap">
        <Modal
          className="parking-configuration-modal"
          isOpen={modalIsOpen}
          ariaHideApp={false}
          onRequestClose={handleModalClose}
        >
          <div className="parking-configuration">
            <div className="parking-configuration-title">
              {I18n.t("parking.page.categoryChange.title", {
                slotName: selectedSlotName,
              })}
            </div>
            <div className="parking-configuration-user-field">
              <div className="input-group col-xs-12 p-total-0 wp-initial">
                <Select
                  className="labeled-field-dropdown"
                  value={selectedCategory ? selectedCategory : originalCategory ? {label: originalCategory.name, value: originalCategory.id} : originalCategory}
                  placeholder={I18n.t(
                    "parking.page.categoryChange.category.placeholder"
                  )}
                  options={searchFieldsData.categoriesAllData.map((f) => ({
                    label: f.name.value,
                    value: f.id.value,
                  }))}
                  onChange={handleSlotCategoryChanged}
                />
              </div>
              <span style={{ color: "red", display: "block" }}>
                {categoryModalError}
              </span>
              <button
                onClick={handleChangeCategorySubmit}
                disabled={
                  categoryModalLoading ||
                  !selectedCategory ||
                  selectedCategory.value === originalCategory.id
                }
                className="btn btn-bold btn-buffer btn-success parking-submit-button"
              >
                {I18n.t("parking.page.categoryChange.submit")}
              </button>
            </div>
          </div>
        </Modal>
        <div className="parking-page-slots-info">
          <ParkingSlotsInfo
            totalSlotsData={totalSlotsData}
            categoriesData={categoriesData}
          />
        </div>
        <div className="parking-page-table-info">
          <ParkingSlotTableContainer
            searchFields={tableSearchFields}
            searchFieldsData={searchFieldsData}
            tableProps={{
              ...tableProps,
            }}
            handleCleanAllClicked={() => handleCleanAllClicked("table")}
            handleFetchData={(searchFields) =>
              handleFetchData("table", searchFields)
            }

            handleSearchFieldValueChanged={(fieldId, value) =>
              handleSearchFieldValueChanged("table", fieldId, value)
            }
            handleParkingTableSlotClicked={handleParkingTableSlotClicked}
          />
        </div>
        <div className="parking-page-graph-info">
          <ParkingSlotGraphContainer
            searchFields={graphSearchFields}
            searchFieldsData={searchFieldsData}
            graphProps={{
              ...graphProps,
            }}
            handleCleanAllClicked={() => handleCleanAllClicked("graph")}
            handleFetchData={(searchFields) =>
              handleFetchData("graph", searchFields)
            }
            handleSearchFieldValueChanged={(fieldId, value) =>
              handleSearchFieldValueChanged("graph", fieldId, value)
            }
          />
        </div>
      </div>
    );
}

export default ParkingPage;